__turbopack_context__.v({
  "agreeButton": "PolicyModalShell-module__6F2pGa__agreeButton",
  "agreeButtonDisabled": "PolicyModalShell-module__6F2pGa__agreeButtonDisabled",
  "body": "PolicyModalShell-module__6F2pGa__body",
  "bodyUnread": "PolicyModalShell-module__6F2pGa__bodyUnread",
  "closeButton": "PolicyModalShell-module__6F2pGa__closeButton",
  "dialog": "PolicyModalShell-module__6F2pGa__dialog",
  "footer": "PolicyModalShell-module__6F2pGa__footer",
  "overlay": "PolicyModalShell-module__6F2pGa__overlay",
  "prose": "PolicyModalShell-module__6F2pGa__prose",
  "scrollThumb": "PolicyModalShell-module__6F2pGa__scrollThumb",
  "scrollbar": "PolicyModalShell-module__6F2pGa__scrollbar",
  "stage": "PolicyModalShell-module__6F2pGa__stage",
  "title": "PolicyModalShell-module__6F2pGa__title",
  "viewport": "PolicyModalShell-module__6F2pGa__viewport",
});
